import React, { createContext, useState } from 'react'

type EditProps = {
  editMode: boolean
  updateEditMode: (s: boolean) => void
}

export type ProviderState = {
  other?: string
} & EditProps

export const EditModeContext = createContext<ProviderState>({} as ProviderState)

export const EditModeProvider: React.FC = ({ children }) => {
  const [editMode, setEditMode] = useState<boolean>(false)

  const updateEditMode = (s: boolean) => {
    setEditMode(s)
  }

  return (
    <EditModeContext.Provider value={{ editMode, updateEditMode }}>
      {children}
    </EditModeContext.Provider>
  )
}
export const useEditMode = (): ProviderState =>
  React.useContext(EditModeContext)
